import { UpdateCartItemRequest } from '@/communication/UpdateCartItemRequest';
import { reactive, Ref, ref } from 'vue';
import { useBroadcast } from '@/composables/UseBroadcast';
import { useQuoteStore } from '@/stores/Quote/QuoteStore';
import { AddSimpleProductToCartRequest } from '@/communication/AddSimpleProductToCartRequest.ts';

export function useSimpleProductAddToCart() {
  const quoteStore = useQuoteStore();
  const broadcast = useBroadcast();
  const addSimpleProductToCartRequest = reactive(
    new AddSimpleProductToCartRequest()
  );
  const updateRequest = reactive(new UpdateCartItemRequest());

  const isRequesting: Ref<boolean> = ref(false);
  const isAwaitingRedirect: Ref<boolean> = ref(false);

  async function addSimpleProductToCart(): Promise<void> {
    try {
      isRequesting.value = true;

      await addSimpleProductToCartRequest
        .setProductSku(window.simple_product!.connected_product.sku)
        .setProductId(window.product.entity_id)
        .setImageUrl(window.simple_product!.image_url)
        .getResponse();
    } catch (e) {
      isRequesting.value = false;
      throw e;
    }

    isAwaitingRedirect.value = true;
    isRequesting.value = false;

    emitAddedQuoteItemEvent();

    window.location.href = window.cart_url;
  }

  function emitAddedQuoteItemEvent(): void {
    const quoteId = quoteStore.quoteId;
    if (quoteId) {
      broadcast.emitQuoteEvent('added-quote-item', quoteId);
    }
  }

  return {
    updateRequest,
    isRequesting,
    isAwaitingRedirect,
    addSimpleProductToCart,
  };
}
